/* eslint-disable  */
import {get} from 'lodash'
import { Output } from '../../Text'
import { Analytics } from './index'
import { isHeycarDealer } from "../../common/JourneyType";

const pushSpecificDataToDatalayer = storefrontData => {
  return Analytics.addToDatalayer({
    "core.category.maturityLevel": isHeycarDealer( get(storefrontData, 'salesChannel.originSystem')) ? "Lead" : "Online contract",
    "product[0].attributes.typeOfSale": isHeycarDealer( get(storefrontData, 'salesChannel.originSystem')) ? "Hybrid sales" : "Online sales",
  })
}

export function pushStorefrontDataToDatalayer(storefrontData){
  pushSpecificDataToDatalayer(storefrontData);
  Analytics.addToDatalayer({
    "core.attributes.transactionID": get(storefrontData, "transaction.id"),
    'product[0].attributes.recurringPayment': get(storefrontData, 'financialProduct.calculation.paymentFrequency'),
    'product[0].attributes.recurringPayment': get(storefrontData, 'financialProduct.calculation.monthlyTotalRateAmount'),
    'product[0].attributes.duration': get(storefrontData, 'financialProduct.calculation.duration'),
    'product[0].attributes.durationUnit': get(storefrontData, 'financialProduct.calculation.durationUnit'),
    'product[0].attributes.yearlyMileage': get(storefrontData, 'financialProduct.calculation.yearlyMileage'),
    'product[0].attributes.excessMileage': get(storefrontData, 'financialProduct.calculation.excessMileage'),
    'product[0].attributes.mileageUnit': get(storefrontData, 'financialProduct.calculation.mileageUnit'),
    'product[0].attributes.paymentType': get(storefrontData, 'financialProduct.calculation.paymentType'),
    'product[0].attributes.netLoanAmount': get(storefrontData, 'financialProduct.calculation.netLoanAmount'),
    'product[0].attributes.grossLoanAmount': get(storefrontData, 'financialProduct.calculation.grossLoanAmount'),
    'product[0].attributes.downPaymentAmount': get(storefrontData, 'financialProduct.calculation.downPaymentAmount'),
    'product[0].attributes.nominalInterestRate': get(storefrontData, 'financialProduct.calculation.nominalInterestRate'),
    'product[0].attributes.nominalInterestAmount': get(storefrontData, 'financialProduct.calculation.nominalInterestAmount'),
    'product[0].vehicleModel[0].manufacturer': get(storefrontData, 'vehicleData.model.manufacturer'),
    'product[0].vehicleModel[0].name': get(storefrontData, 'vehicleData.model.name'),
    'product[0].vehicleModel[0].modelVariation': get(storefrontData, 'vehicleData.model.modelVariation')
      ? get(storefrontData, 'vehicleData.model.modelVariation')
      : get(storefrontData, 'vehicleData.model.description'),
    'product[0].vehicleModel[0].year': get(storefrontData, 'vehicleData.model.year'),
    'product[0].vehicleModel[0].year': get(storefrontData, 'vehicleData.model.year'),
    'product[0].vehicleModel[0].modelLine': get(storefrontData, 'vehicleData.model.modelLine'),
    'product[0].vehicleModel[0].descriptionLong': get(storefrontData, 'vehicleData.model.descriptionLong'),
    'product[0].vehicleModel[0].bodyType': get(storefrontData, 'vehicleData.model.bodyType'),
    'product[0].vehicleModel[0].currentMileage': get(storefrontData, 'vehicleData.odometer'),
    'product[0].vehicleModel[0].currentMileageUnit': get(storefrontData, 'vehicleData.odometerUnit'),
    'product[0].vehicleModel[0].initialRegistrationDate': get(storefrontData, 'vehicleData.initialRegistrationDate'),
    'product[0].vehicleModel[0].currency': Output.resolve("generic.currencySymbol"),
    'product[0].vehicleModel[0].endPrice_localCurrency': get(storefrontData, 'vehicleData.rrpAmount'),
    'product[0].vehicleModel[0].manufacturerCode': get(storefrontData, 'vehicleData.model.manufacturer'),
    'product[0].vehicleModel[0].typeCode': get(storefrontData, 'vehicleData.model.typeCode'),
    'product[0].vehicleModel[0].colorExterior': get(storefrontData, 'vehicleData.model.colorExterior'),
    'product[0].vehicleModel[0].engine.fuelType': get(storefrontData, 'vehicleData.model.engine.fuelType'),
    'customerData.loginStatus': true,
    'customerData.yearOfBirth': get(storefrontData, 'birthDate'),
    'customerData.gender': get(storefrontData, 'salutation'),
    'customerData.address.zipCode': get(storefrontData, 'postcode'),
  })
}
